var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStethescope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2,13v3.2c0,1.6-0.6,3.1-1.8,4.3c-1.1,1.1-2.7,1.8-4.3,1.8c-1.6,0-3.1-0.6-4.3-1.8c-1.1-1.1-1.8-2.7-1.8-4.3 v-0.7c-1.3-0.2-2.6-0.9-3.4-1.9c-0.9-1-1.4-2.3-1.4-3.7V5.4c0-0.4,0.1-0.9,0.3-1.3c0.2-0.4,0.5-0.7,0.9-1C3.6,2.7,3.7,2.3,4,2 c0.3-0.3,0.7-0.5,1.1-0.6c0.4-0.1,0.8,0,1.2,0.2C6.7,1.8,7,2.1,7.2,2.5c0.2,0.4,0.2,0.8,0.1,1.2c-0.1,0.4-0.3,0.8-0.7,1 C6.3,5,5.9,5.2,5.5,5.2C5,5.2,4.6,5,4.3,4.8C4.2,5,4.1,5.2,4.1,5.4v4.5c0,1,0.4,2,1.2,2.8C6,13.4,7,13.8,8,13.8c1,0,2-0.4,2.8-1.2 c0.7-0.7,1.2-1.7,1.2-2.8V5.4c0-0.2-0.1-0.4-0.2-0.5c-0.4,0.2-0.8,0.3-1.2,0.3c-0.4,0-0.8-0.2-1.1-0.5C9.1,4.4,8.9,4,8.8,3.6 C8.8,3.2,8.8,2.8,9,2.4C9.2,2,9.5,1.7,9.9,1.5c0.4-0.2,0.8-0.2,1.2-0.1c0.4,0.1,0.8,0.3,1,0.7c0.3,0.3,0.4,0.7,0.4,1.2 c0.3,0.2,0.6,0.6,0.8,0.9c0.2,0.4,0.3,0.8,0.3,1.2v4.5c0,1.4-0.5,2.7-1.4,3.7c-0.9,1-2.1,1.7-3.4,1.9v0.7c0,1.1,0.5,2.2,1.3,3 c0.8,0.8,1.9,1.3,3,1.3s2.2-0.5,3-1.3c0.8-0.8,1.3-1.9,1.3-3V13c-0.8-0.2-1.5-0.7-1.9-1.4c-0.5-0.7-0.6-1.5-0.5-2.3 c0.1-0.8,0.5-1.6,1.1-2.1c0.6-0.5,1.4-0.8,2.2-0.8c0.8,0,1.6,0.3,2.2,0.8c0.6,0.5,1,1.3,1.1,2.1c0.1,0.8-0.1,1.6-0.5,2.3 C20.6,12.3,20,12.8,19.2,13L19.2,13z M19.9,9.8c0-0.3-0.1-0.6-0.3-0.9c-0.2-0.3-0.4-0.5-0.7-0.6c-0.3-0.1-0.6-0.2-0.9-0.1 c-0.3,0.1-0.6,0.2-0.8,0.4c-0.2,0.2-0.4,0.5-0.4,0.8c-0.1,0.3,0,0.6,0.1,0.9c0.1,0.3,0.3,0.6,0.6,0.7c0.3,0.2,0.6,0.3,0.9,0.3 c0.4,0,0.8-0.2,1.2-0.5C19.8,10.6,19.9,10.2,19.9,9.8L19.9,9.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethescope);
export default __webpack_public_path__ + "static/media/stethescope.3a79acba2153efbd1155a137e601cc44.svg";
export { ForwardRef as ReactComponent };